import useAlert from '@/services/useAlert';
import { useI18n } from 'vue-i18n';
import { useOnline } from '@vueuse/core';
import { watch } from 'vue';

const registerGlobalEvents = () => {
  addOnlineOfflineEvents();
};

const addOnlineOfflineEvents = () => {
  const { showAlert, closeAlert } = useAlert();
  const { t } = useI18n();
  const online = useOnline();

  watch(online, (online: boolean) => {
    if (!online) {
      showAlert({
        title: t('ALERT.OFFLINE.TITLE'),
        text: t('ALERT.OFFLINE.TEXT'),
      });
    } else {
      closeAlert();
    }
  });
};

export default () => ({
  registerGlobalEvents,
});
